import Registration from "../../components/auth/registration/Registration.tsx";

function RegistrationPage() {
    return (
        <>
            <Registration/>
        </>
    );
}

export default RegistrationPage;